<ng-container *transloco="let convert;">
  @if (questionsResponse$ | async; as questionsResponse) {
    <section class="container">
      @if (questionsResponse.length === 0) {
        <section role="alert">
          <h2 class="text-center text-brand mt-1" tabindex="-1">{{convert('sellModule.question.questionShell.textCurrentlyQuestion')}}</h2>
        </section>
      } @else {
        @for (dealer of questionsResponse; track dealer; let i = $index) {
          <lib-question
            [identifier]="i.toString()"
            [dealer]="dealer"
          ></lib-question>
        }
      }
    </section>
  }
</ng-container>
